import { gql } from "@apollo/client"

const JOB_STEP_COMPLETED_BY_FIELDS = gql`
  fragment JobStepCompletedByFields on User {
    id
    status
    fullName
    firstName
    lastName
    avatar {
      key
    }
    groups {
      id
      name
    }
    locations {
      id
      name
    }
    activeAt
  }
`

const JOB_STEP_UPLOADS_FIELDS = gql`
  fragment JobStepUploadsFields on UploadInfo {
    id
    key
    fileName
    fileGroup
    fileSize
  }
`

const JOB_STEP_NOTES_FIELDS = gql`
  fragment JobStepNotesFields on JobProcessStepNote {
    id
    text
    author {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    createdAt
    updatedAt
    edited @client
  }
`

export { JOB_STEP_COMPLETED_BY_FIELDS, JOB_STEP_UPLOADS_FIELDS, JOB_STEP_NOTES_FIELDS }
